import type { MouseEvent, PropsWithChildren } from 'react';

import { Button } from 'components/Button/Button';

type Props = {
  open?: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  'data-qa-id'?: string;
};

export function ExpandButton({
  open,
  onClick,
  children,
  'data-qa-id': qaId,
}: PropsWithChildren<Props>) {
  return (
    <Button
      data-qa-id={qaId}
      type="button"
      variant="tertiary"
      onClick={onClick}
      icon={{
        type: 'normalized',
        name: open ? 'chevron-up' : 'chevron-down',
        color: 'brandBlue',
        size: 16,
      }}
      iconPosition="right"
    >
      {children}
    </Button>
  );
}
